// extracted by mini-css-extract-plugin
export default {"circleTrans":"Landing_circleTrans__9vYlY","typo":"Landing_typo__uvK3u","div":"Landing_div__jLnlY","link":"Landing_link__3Nu5c"};